import React, { Component } from "react";
import { auth } from "../../../utils/auth";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { postRequest } from "../../../utils/request";

class Create extends Component {
    state = {
        errors: {},
    };
    createCategoria = async event => {
        event.preventDefault();

        const data = new FormData(event.target);
        const response = await postRequest(apiUrl("taxonomias"), data);

        if (response.success) {
            this.props.getTaxonomias();
            this.props.toggle();
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { errors } = this.state;
        const { toggle, taxonomia } = this.props;
        return (
            <form method='post' onSubmit={this.createCategoria}>
                <div className='popup__header'>Nueva Categoría</div>
                <div className='popup__body'>
                    <Form taxonomia={taxonomia} errors={errors} />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'>
                        Crear
                    </button>
                </div>
            </form>
        );
    }
}

export default Create;
